import React from "react";

import List from "./List";
import Filters from "./Filters";

const Restaurants = () => {
  return (
    <div>
      <Filters />
      <List />
    </div>
  );
};

export default Restaurants;
